import React, { useState } from 'react';

import { Alert } from 'antd';
import Axios from 'axios';
import { Formik, Field } from 'formik';

import { forceReloadInvoice } from '@hooks/API/UseInvoices';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWPaymentTermSelector } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const EditPaymentTermsDrawer = ({ onClose, data }) => {
    const [touchForm, setTouchForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const initialValues = {
        PaymentTermCode: data.PaymentTermCode ? data.PaymentTermCode : null,
    };

    const savePaymentTermsStatus = async (values, setSubmitting) => {
        setSubmitting(true);
        setErrorMessage(null);
        try {
            await Axios.put(`/invoices/paymentterms`, {
                InvoiceID: data.ID,
                PaymentTermCode: values.PaymentTermCode,
            });
            forceReloadInvoice(data.ID);
            onClose();
        } catch (e) {
            setErrorMessage(`Error changing payment terms: ${e?.message || 'unknown error'}`);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose} title="Change Payment Terms">
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    savePaymentTermsStatus(values, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                        <Field
                            component={NWPaymentTermSelector}
                            label="Payment Terms"
                            name="PaymentTermCode"
                            value={values.PaymentTermCode}
                        />
                        {errorMessage && <Alert style={{ margin: '1rem 0' }} message={errorMessage} type="error" />}
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default EditPaymentTermsDrawer;
